module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Reporte devolución")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  }), _vm._v(" "), (_vm.multitabulacion) ? _c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion2),
      callback: function($$v) {
        _vm.codigotabulacion2 = $$v
      },
      expression: "codigotabulacion2"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "multiple",
      "dark": ""
    },
    model: {
      value: (_vm.multitabulacion),
      callback: function($$v) {
        _vm.multitabulacion = $$v
      },
      expression: "multitabulacion"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.buscar
    }
  }, [_vm._v("\n             Buscar")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n             Cerrar")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [(_vm.codigotabulacion) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialognuevo = true
      }
    }
  }, [_vm._v("\n             Nuevo")]) : _vm._e()], 1), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tbody', _vm._l((_vm.productos), function(producto) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "green--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editardevolucion(producto)
        }
      }
    }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          producto.activo = !producto.activo
        }
      }
    }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(producto.producto))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(producto.total))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('v-flex', [(producto.activo) ? _c('v-text-field', {
      attrs: {
        "label": "ingreso",
        "type": "number"
      },
      model: {
        value: (producto.ingreso),
        callback: function($$v) {
          _vm.$set(producto, "ingreso", $$v)
        },
        expression: "producto.ingreso"
      }
    }) : _vm._e()], 1)], 1)])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-action', [_c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(_vm.productos) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = true
      }
    }
  }, [_vm._v("\n             Completar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.getters.gettipo !== 'bodeguero'),
      expression: "this.$store.getters.gettipo !== 'bodeguero'"
    }],
    staticClass: "print green darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogcuadrar = true
      }
    }
  }, [_vm._v("\n             Cuadrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "print yellow darken-4",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogrevision = true, _vm.native = true
      }
    }
  }, [_vm._v("\n             Revision")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Ingrese código del cliente")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Codigo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.codigo),
      callback: function($$v) {
        _vm.codigo = $$v
      },
      expression: "codigo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardardevolucion(_vm.codigo)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogcuadrar),
      callback: function($$v) {
        _vm.dialogcuadrar = $$v
      },
      expression: "dialogcuadrar"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "totales"
  }, [_c('p', [_vm._v("Total A Entregar: " + _vm._s(_vm.deuda))]), _vm._v(" "), _c('p', [_vm._v("Entregado: " + _vm._s(_vm.total))]), _vm._v(" "), _c('p', [_vm._v("Falta: " + _vm._s(_vm.faltante))])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "tabulacion",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cuadrar($event)
      }
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  }), _vm._v(" "), (_vm.multitabulacion) ? _c('v-text-field', {
    attrs: {
      "label": "tabulacion2"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cuadrar($event)
      }
    },
    model: {
      value: (_vm.codigotabulacion2),
      callback: function($$v) {
        _vm.codigotabulacion2 = $$v
      },
      expression: "codigotabulacion2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cuadrar($event)
      }
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "multiple"
    },
    model: {
      value: (_vm.multitabulacion),
      callback: function($$v) {
        _vm.multitabulacion = $$v
      },
      expression: "multitabulacion"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content_tabulacion"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.tbilletes
    },
    on: {
      "click": _vm.activarbilletes
    }
  }, [_c('span', [_vm._v("Billetes")])])]), _vm._v(" "), _c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.tmonedas
    },
    on: {
      "click": _vm.activarmonedas
    }
  }, [_c('span', [_vm._v("Monedas")])]), _vm._v(" "), _c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.totros
    },
    on: {
      "click": _vm.activarotros
    }
  }, [_c('span', [_vm._v("Otros")])]), _vm._v(" "), _c('div', {
    staticClass: "tabulacion",
    class: {
      progreso: _vm.tgastos
    },
    on: {
      "click": _vm.activargastos
    }
  }, [_c('span', [_vm._v("Gastos")])])], 1), _vm._v(" "), (_vm.tbilletes) ? _c('div', {
    staticClass: "detallebilletes",
    class: {
      active: _vm.tbilletes
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Q. 200",
      "type": "number"
    },
    model: {
      value: (_vm.b200),
      callback: function($$v) {
        _vm.b200 = $$v
      },
      expression: "b200"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 100",
      "type": "number"
    },
    model: {
      value: (_vm.b100),
      callback: function($$v) {
        _vm.b100 = $$v
      },
      expression: "b100"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 50",
      "type": "number"
    },
    model: {
      value: (_vm.b50),
      callback: function($$v) {
        _vm.b50 = $$v
      },
      expression: "b50"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 20",
      "type": "number"
    },
    model: {
      value: (_vm.b20),
      callback: function($$v) {
        _vm.b20 = $$v
      },
      expression: "b20"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 10",
      "type": "number"
    },
    model: {
      value: (_vm.b10),
      callback: function($$v) {
        _vm.b10 = $$v
      },
      expression: "b10"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 5",
      "type": "number"
    },
    model: {
      value: (_vm.b5),
      callback: function($$v) {
        _vm.b5 = $$v
      },
      expression: "b5"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q. 1",
      "type": "number"
    },
    model: {
      value: (_vm.b1),
      callback: function($$v) {
        _vm.b1 = $$v
      },
      expression: "b1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tmonedas) ? _c('div', {
    staticClass: "detallemonedas",
    class: {
      active: _vm.tmonedas
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Q.1.00",
      "type": "number"
    },
    model: {
      value: (_vm.m1),
      callback: function($$v) {
        _vm.m1 = $$v
      },
      expression: "m1"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.50",
      "type": "number"
    },
    model: {
      value: (_vm.m50),
      callback: function($$v) {
        _vm.m50 = $$v
      },
      expression: "m50"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.25",
      "type": "number"
    },
    model: {
      value: (_vm.m25),
      callback: function($$v) {
        _vm.m25 = $$v
      },
      expression: "m25"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.10",
      "type": "number"
    },
    model: {
      value: (_vm.m10),
      callback: function($$v) {
        _vm.m10 = $$v
      },
      expression: "m10"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Q 0.5",
      "type": "number"
    },
    model: {
      value: (_vm.m5),
      callback: function($$v) {
        _vm.m5 = $$v
      },
      expression: "m5"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.totros) ? _c('div', {
    staticClass: "detalleotros",
    class: {
      active: _vm.totros
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cheque",
      "type": "number"
    },
    model: {
      value: (_vm.cheque),
      callback: function($$v) {
        _vm.cheque = $$v
      },
      expression: "cheque"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Depositos",
      "type": "number"
    },
    model: {
      value: (_vm.boleta),
      callback: function($$v) {
        _vm.boleta = $$v
      },
      expression: "boleta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "No boleta",
      "type": "number"
    },
    model: {
      value: (_vm.no_boleta),
      callback: function($$v) {
        _vm.no_boleta = $$v
      },
      expression: "no_boleta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "No boleta 2",
      "type": "number"
    },
    model: {
      value: (_vm.no_boleta2),
      callback: function($$v) {
        _vm.no_boleta2 = $$v
      },
      expression: "no_boleta2"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "No boleta 3",
      "type": "number"
    },
    model: {
      value: (_vm.no_boleta3),
      callback: function($$v) {
        _vm.no_boleta3 = $$v
      },
      expression: "no_boleta3"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "observaciones"
    },
    model: {
      value: (_vm.observaciones),
      callback: function($$v) {
        _vm.observaciones = $$v
      },
      expression: "observaciones"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Calificación Compañeros"
    },
    model: {
      value: (_vm.calificacion),
      callback: function($$v) {
        _vm.calificacion = $$v
      },
      expression: "calificacion"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tgastos) ? _c('div', {
    staticClass: "detallegastos",
    class: {
      active: _vm.tgastos
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "recibos",
      "type": "number"
    },
    model: {
      value: (_vm.gastos),
      callback: function($$v) {
        _vm.gastos = $$v
      },
      expression: "gastos"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "gastos con factura",
      "type": "number"
    },
    model: {
      value: (_vm.gastos_factura),
      callback: function($$v) {
        _vm.gastos_factura = $$v
      },
      expression: "gastos_factura"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogcuadrar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.cuadrado && !_vm.caja.id && _vm.buscotabulacion) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogcuadrar = false, _vm.dialogrevision = true
      }
    }
  }, [_vm._v("Aceptar")]) : _vm._e(), _vm._v(" "), (_vm.cuadrado && _vm.caja.id && _vm.buscotabulacion) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.modificarcuadrado(_vm.codigo)
      }
    }
  }, [_vm._v("Modificar")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialognuevo),
      callback: function($$v) {
        _vm.dialognuevo = $$v
      },
      expression: "dialognuevo"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos2), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n              " + _vm._s(product.producto) + "\n           ")])
  }), 0), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Cantidad:",
      "type": "number"
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialognuevo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.guardaritemdevolucion($event)
      }
    }
  }, [_vm._v("guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogrevision),
      callback: function($$v) {
        _vm.dialogrevision = $$v
      },
      expression: "dialogrevision"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "red",
    attrs: {
      "pt0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Revisión")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion),
      callback: function($$v) {
        _vm.codigotabulacion = $$v
      },
      expression: "codigotabulacion"
    }
  }), _vm._v(" "), (_vm.multitabulacion) ? _c('v-text-field', {
    attrs: {
      "label": "Codigo",
      "type": "number",
      "dark": ""
    },
    model: {
      value: (_vm.codigotabulacion2),
      callback: function($$v) {
        _vm.codigotabulacion2 = $$v
      },
      expression: "codigotabulacion2"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.cuadrar
    }
  }, [_vm._v("\n                 Buscar")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mt-3": ""
    }
  }, [(_vm.activo) ? _c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.activo = !_vm.activo
      }
    }
  }, [_vm._v("\n                 Cerrar")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "tres candados"
    },
    model: {
      value: (_vm.revision.tres_candados),
      callback: function($$v) {
        _vm.$set(_vm.revision, "tres_candados", $$v)
      },
      expression: "revision.tres_candados"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "llantas c/aire"
    },
    model: {
      value: (_vm.revision.llantas_con_aire),
      callback: function($$v) {
        _vm.$set(_vm.revision, "llantas_con_aire", $$v)
      },
      expression: "revision.llantas_con_aire"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "limpieza cabina"
    },
    model: {
      value: (_vm.revision.limpiez_cabina),
      callback: function($$v) {
        _vm.$set(_vm.revision, "limpiez_cabina", $$v)
      },
      expression: "revision.limpiez_cabina"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "limpieza frurgon"
    },
    model: {
      value: (_vm.revision.limpieza_frurgon),
      callback: function($$v) {
        _vm.$set(_vm.revision, "limpieza_frurgon", $$v)
      },
      expression: "revision.limpieza_frurgon"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "troquet"
    },
    model: {
      value: (_vm.revision.troquet),
      callback: function($$v) {
        _vm.$set(_vm.revision, "troquet", $$v)
      },
      expression: "revision.troquet"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "en buen estado"
    },
    model: {
      value: (_vm.revision.en_buen_estado),
      callback: function($$v) {
        _vm.$set(_vm.revision, "en_buen_estado", $$v)
      },
      expression: "revision.en_buen_estado"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "lavado"
    },
    model: {
      value: (_vm.revision.lavado),
      callback: function($$v) {
        _vm.$set(_vm.revision, "lavado", $$v)
      },
      expression: "revision.lavado"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "observaciones"
    },
    model: {
      value: (_vm.revision.comentario),
      callback: function($$v) {
        _vm.$set(_vm.revision, "comentario", $$v)
      },
      expression: "revision.comentario"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogrevision = false, _vm.dialogcuadrar = !_vm.native, _vm.native = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.cuadrado && !_vm.caja.id && _vm.buscotabulacion) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        !_vm.native ? _vm.guardarcuadrado(_vm.codigo) : _vm.updateTabulacion()
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.caja.id) ? _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateTabulacion()
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73fae098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReporteDevolucion.vue
// module id = 441
// module chunks = 1